<template>
  <v-container class="my-8 content-constraint">
    <!--    <v-breadcrumbs :items="breadcrumbItems" divider=">" />-->
    <div v-if="!product">
      <h1 class="font-title text-center">
        Product Not Found
      </h1>
      <v-img src="/no-page-found.svg" width="310px" max-width="60vw" class="mx-auto my-12" />
    </div>

    <div
      v-if="product && !IsGiftCard()"
>
          <date-bought-notification :product-id="product.id" />
    </div>
    <div
      v-if="product && !IsGiftCard()"
      class="product-detail-wrapper d-flex flex-column flex-md-row align-center align-md-start justify-center justify-md-space-between"
    >
      <div class="product-photos-wrapper d-flex flex-column scale-with-screen">
        <v-carousel
          v-model="carouselIndex"
          :show-arrows="false"
          delimiter-icon="mdi-circle-outline"
          class="photo-carousel d-block d-md-none"
          light
          height="300"
        >
          <v-carousel-item>
            <base-image
              :source="selectedProduct.featuredImageUrl | fullImagePath('M')"
              :alt="selectedProduct.title + ' Cover Image'"
              max-width="328"
              min-width="200"
              max-height="300"
              contain
            />
          </v-carousel-item>
          <v-carousel-item
            v-for="(image, i) of selectedProduct.images"
            :key="image.name + '-supporting-image_' + i"
          >
            <v-img
              v-if="image.publisherUrl"
              :src="image.publisherUrl | fullImagePath('S')"
              :alt="image.name + '-supporting-image_' + i"
              max-height="450"
              contain
            />
            <v-img
              v-if="!image.publisherUrl && image.alternateUrl"
              :src="image.alternateUrl"
              :alt="image.name + '-supporting-image_' + i"
              max-height="450"
              contain
            />
          </v-carousel-item>
          <v-carousel-item
            v-for="video of videos"
            :key="video.title"
          >
            <div class="video" v-html="video.html" />
          </v-carousel-item>
        </v-carousel>
        <div class="product-photos d-none d-md-flex align-start">
          <div class="flex-column">
            <div
              v-for="(image, i) of selectedProduct.images"
              :key="image.name + '-supporting-image_' + i"
              v-a11y-clickable
              class="photo-container clickable"
              aria-label="select photo"
              @click="selectImage(image, i)"
            >
              <v-img
                v-if="image.publisherUrl"
                :src="image.publisherUrl | fullImagePath('XS')"
                :alt="image.name + ' Image'"
                max-width="78"
                contain
              />
              <v-img
                v-if="!image.publisherUrl && image.alternateUrl"
                :src="image.alternateUrl"
                :alt="image.name + ' Image'"
                max-width="78"
                contain
              />
            </div>
            <div v-for="video of videos" :key="video.title" class="photo-container video-container clickable">
              <video-dialog v-if="video" :video="video">
                <img src="/play-icon.svg" alt="video play icon" class="video-overlay">
                <v-img
                  :src="video.thumbnail_url"
                  :alt="video.title"
                  max-width="78"
                  contain
                />
              </video-dialog>
            </div>
          </div>
          <div class="d-flex flex-column">
            <div class="photo-container">
              <base-image
                :source="featuredImageUrl"
                :alt="selectedProduct.title + ' Image'"
                @imageLoaded="imageLoaded=true"
              />
            </div>
          </div>
        </div>
         <div class="mt-5 share-network-container">
          <div class="d-block share-network-title">
            SHARE
          </div>
          <div class="d-flex mt-2">
            <ShareNetwork
              network="facebook"
              :url="shareUrl"
              :title="selectedProductTitle"
              class="social-network-item"
            >
              <v-icon color="primary" class="mr-2 mdi">
                      mdi-facebook
              </v-icon>
            </ShareNetwork>
            <ShareNetwork
              network="twitter"
              :url="shareUrl"
              :title="selectedProductTitle"
              twitter-user="bakerbookstore"
              class="social-network-item"
            >
              <v-icon color="primary" class="mr-2 mdi">
                      mdi-twitter
              </v-icon>
            </ShareNetwork>
            <ShareNetwork
              network="pinterest"
              :url="shareUrl"
              :title="selectedProductTitle"
              :media="featuredImageUrl"
              class="social-network-item"
            >
              <v-icon color="primary" class="mr-2 mdi">
                      mdi-pinterest
              </v-icon>
            </ShareNetwork>
            <ShareNetwork
              network="email"
              :url="shareUrl"
              :description="'\r\nVisit Baker Book House to view: ' + selectedProductTitle"
              :title="selectedProduct.title + (selectedProduct.author ? ' by ' + selectedProduct.author : '')"
              class="social-network-item"
            >
              <v-icon color="primary" class="mr-2 mdi">
                      mdi-email
              </v-icon>
            </ShareNetwork>
          </div>
        </div>
      </div>
      <v-card
        class="product-card-wrapper d-flex flex-column flex-grow-1 mt-7 mb-4 my-md-0 mx-3 mx-sm-0"
        :class="{'ribbon-padding': $breakpoint.is.smAndDown && selectedProduct.flag && selectedProduct.relatedPromotions.length > 1 }"
      >
        <ribbon v-if="selectedProduct.flag || selectedProduct.relatedPromotions" :callout-text="selectedProduct.flag" :secondary-ribbons="selectedProduct.relatedPromotions" />
        <div v-hide-if-not-authenticated class="favorite-icon">
          <v-tooltip
            v-model="showWishlistTooltip"
            content-class="wishlist-tooltip"
            top
            right
          >
            <template v-slot:activator="{ on }">
              <div
                class="d-flex"
              >
                <v-icon
                  v-if="!itemInWishList"
                  v-a11y-clickable
                  class="clickable primary--text"
                  aria-label="add to wish list"
                  @click="addToWishList"
                >
                  mdi-heart-outline
                </v-icon>
                <v-icon
                  v-if="itemInWishList"
                  v-a11y-clickable
                  class="clickable primary--text"
                  aria-label="remove from wish list"
                  @click="removeFromWishList"
                >
                  mdi-heart
                </v-icon>
              </div>
            </template>
            <span>Added! <nuxt-link to="/wishlist">See your wishlist!</nuxt-link></span>
          </v-tooltip>
        </div>
        <div class="product-about-wrapper">
          <v-card-title>{{ selectedProduct.title }}</v-card-title>
          <v-card-subtitle>{{ selectedProduct.subtitle }}</v-card-subtitle>
          <v-card-text v-if="contributors">
            by {{ contributors }}
          </v-card-text>
          <div v-if="selectedProduct.totalRatings > 0" class="product-reviews-wrapper d-flex align-center">
            <base-rating v-if="selectedProduct.roundedRating >= 0" v-model="selectedProduct.roundedRating" readonly />
            <a v-if="selectedProduct.totalRatings" href="#product-review-anchor">
              {{ selectedProduct.totalRatings }} Customer Reviews
            </a>
          </div>
        </div>
        <div v-if="product.productTypeId !== 44">
        <div v-if="!product.isNotForIndividualSale" class="product-options-wrapper">
          <div v-if="selectedProduct">
            <div v-if="!selectedProduct.isOrderable" class="error--text font-large font-weight-bold mt-4">
              Item Out of Stock
            </div>
            <div class="section-heading">
              <span>{{ selectedProduct.type }}</span>
            </div>
            <div class="product-pricing-wrapper d-flex flex-column flex-sm-row align-sm-center justify-space-between">
              <div class="d-flex">
                <v-icon class="new-value-icon accent--text">
mdi-currency-usd
</v-icon>
                <span class="new-value font-weight-bold accent--text">
                   {{ priceWithBulkDiscountsApplied | formatCurrencyNoSymbol }}</span>
                <div v-if="productDiscount > 0" class="old-price font-weight-medium d-flex flex-column">
                    <span class="price"><v-icon class="value primary--text new-value-price">
                        mdi-currency-usd
                        </v-icon>{{ selectedProduct.msrp }}</span>
                  <span class="accent--text">Save {{ productDiscount }}%</span>
                </div>
              </div>
              <div
                class="special-offers mt-1 mt-sm-0 font-medium font-weight-bold primary--text"
              >
                <ul
                  v-if="selectedProduct.bulkDiscounts && selectedProduct.bulkDiscounts.length"
                  class="pt-1 discount-list"
                >
                  <li v-for="discount in selectedProduct.bulkDiscounts" :key="discount.id">
                    {{ discount.percentage * 100 }}% off when you buy {{ discount.quantity }}
                  </li>
                </ul>
                <client-only>
                  <ul
                    v-if="showPromotionList"
                    class="pt-1 discount-list"
                  >
                    <li v-for="(ribbon, i) in selectedProduct.relatedPromotions" :key="'ribbon_'+i">
                      {{ ribbon.name }}
                    </li>
                  </ul>
                </client-only>
              </div>
            </div>
            <client-only>
              <div
                v-if="authenticatedUser && browsingAs && browsingAs.isBakerFirst"
                class="product-pricing-wrapper special-offers mt-1 mt-sm-0 font-medium font-weight-bold primary--text"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                  <span class="special-offers" v-on="on">
                    See Baker First price in cart
                    <v-icon color="primary">
                      mdi-information-outline
                    </v-icon>
                  </span>
                  </template>
                  <span>
                  Baker First members receive Amazon Prime discounts + 2%.
                  Discounts will be automatically applied at checkout unless another
                  promotion that has greater savings is available.
                </span>
                </v-tooltip>
              </div>
            </client-only>
            <client-only>
              <div
                v-if="promotionAppliedInCart"
                class="product-pricing-wrapper special-offers mt-1 mt-sm-0 font-medium font-weight-bold primary--text"
              >
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                  <span class="special-offers" v-on="on">
                    See promotional bulk pricing in cart
                    <v-icon color="primary">
                      mdi-information-outline
                    </v-icon>
                  </span>
                  </template>
                  <span>
                  Quantity based promotions are calculated based on MSRP in the cart to give you the best deal.
                </span>
                </v-tooltip>
              </div>
            </client-only>
          </div>
          <div v-if="selectedProduct.isUsed">
            <div class="section-heading mb-1">
              <span>Condition</span>
            </div>
            <p class="font-medium">
              <span class="font-weight-extra">
                Used<span v-if="selectedProduct.condition">: {{ selectedProduct.condition }}

                <v-tooltip v-if="conditionDescription" top>
                  <template v-slot:activator="{ on }">
                  <span v-on="on">
                    <v-icon color="primary" small>
                      mdi-information-outline
                    </v-icon>
                  </span>
                  </template>
                  <span>
                  <prismic-rich-text
                    :field="conditionDescription"
                    class="no-margin"
                  />
                </span>
                </v-tooltip>

              </span>
              </span>
              <br>
              {{ selectedProduct.conditionDescription }}
            </p>
          </div>
          <client-only>
            <div v-if="showFormatOptions" class="section-heading">
              <span>Format Options</span>
            </div>
            <div v-if="showFormatOptions && $breakpoint.is.xs" class="base-select">
              <v-select
                :value="selectedProduct"
                :items="formatItems"
                item-value="id"
                outlined
                return-object
                hide-details
                placeholder="Select a format..."
                :class="{'mobile': $vuetify.breakpoint.smAndDown}"
                @input="selectFormatOptionFromList($event)"
              >
                <template v-slot:selection="data">
                  <div v-if="data.item.used">
                    <b>{{ usedProducts.length }} Used</b> from <v-icon class="value primary--text new-value-price">
mdi-currency-usd
</v-icon>{{ data.item.price | formatCurrencyNoSymbol }}
                  </div>
                  <b>
                    {{ data.item.type }}
                  </b>
                  &nbsp; {{ data.item.basePrice | formatCurrencyNoSymbol }}
                </template>
                <template v-slot:item="data">
                  <template v-if="data.item.used">
                    <b>{{ usedProducts.length }} Used</b>&nbsp;from <v-icon class="value primary--text new-value-price">
mdi-currency-usd
</v-icon>{{ data.item.price | formatCurrencyNoSymbol }}
                  </template>
                  <template v-else>
                    <b>
                      {{ data.item.type }}
                      <span v-if="data.item.isUsed">
                    (Used<span v-if="data.item.condition"> - {{ data.item.condition }}</span>)
                  </span>
                    </b>
                    &nbsp; {{ data.item.basePrice }}
                  </template>
                </template>
              </v-select>
              <div
                v-if="selectedProduct && selectedProduct.option === 'Used' && productVariants"
                class="font-weight-bold font-medium pt-1 pb-5"
              >
                <span v-a11y-clickable class="primary--text clickable" @click="showUsedBookDialog = true">{{ productVariants.length }} used</span>
                from <v-icon class="value primary--text new-value-price">
mdi-currency-usd
</v-icon>{{ lowestPriceUsedOption | formatCurrencyNoSymbol }}
              </div>
            </div>
            <div v-if="showFormatOptions && $breakpoint.is.smAndUp" class="format-options-wrapper d-flex flex-wrap align-stretch">
              <div
                v-for="(option, i) of formatItems"
                :key="product.title + '-format option_' + i"
              >
                <div
                  v-if="!option.used"
                  v-a11y-clickable
                  class="option d-flex flex-column clickable"
                  :class="{ selected: selectedProduct.id === option.id }"
                  @click="selectFormatOptionFromList(option)"
                >
                  <span
                    class="heading primary--text font-weight-medium"
                    :class="{'font-weight-black': selectedProduct.id === option.id}"
                  >{{ option.type }}
                  <span v-if="option.isUsed" class="font-medium">
                    <br>Used<span v-if="option.condition">: {{ option.condition }}</span>
                  </span>
                  <span v-if="!option.isUsed && usedProducts.length > 0" class="font-medium">
                    <br>New
                  </span>
                </span>
                <span><v-icon class="value primary--text new-value-price">
mdi-currency-usd
</v-icon><span
                    class="value primary--text font-weight-light"
                    :class="{'font-weight-bold': selectedProduct.id === option.id}"
                  >{{ option.basePrice | formatCurrencyNoSymbol }}</span>
                  </span>
                </div>
                <div v-if="option.used">
                  <div
                    v-a11y-clickable
                    class="option mb-0 clickable d-flex flex-column"
                    :class="{'selected': isUsedSelected}"
                    @click="showUsedBookDialog = true"
                  >
                    <span class="heading primary--text font-weight-medium" :class="{'font-weight-black': isUsedSelected}">Used ({{ usedProducts.length }})</span>
                    <span
                      class="value primary--text font-weight-light"
                      :class="{'font-weight-bold': isUsedSelected}"
                    >
                      <v-icon class="value primary--text new-value-price">
mdi-currency-usd
</v-icon>{{ lowestPriceUsedOption | formatCurrencyNoSymbol }}
                    </span>
                  </div>
                  <div v-if="product && usedProducts.length" class="text-right font-weight-bold used-text pt-1 mb-1">
                    <span v-a11y-clickable class="primary--text clickable" @click="showUsedBookDialog = true">{{ usedProducts.length }} used</span>
                    from <v-icon class="value primary--text new-value-price">
mdi-currency-usd
</v-icon>{{ lowestPriceUsedOption | formatCurrencyNoSymbol }}
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="priorityCartMessage && priorityCartMessage.length > 0"
              class="priority-cart-message"
>
              {{ priorityCartMessage }}
            </div>
            <div
              v-if="selectedProduct"
              class="cart-actions-wrapper d-flex flex-column flex-sm-row justify-space-between"
            >
              <div class="quantity">
                <base-quantity-select
                  :quantity="quantityToOrder"
                  label="Quantity"
                  :max="selectedProduct.isUsed ? selectedProduct.quantityAvailable : null"
                  outlined
                  @change="quantityToOrder = $event"
                />
                <small v-if="appliedDiscount" class="accent--text font-small">
                  {{ appliedDiscount.percentage * 100 }}% off when you buy {{ appliedDiscount.quantity }}
                </small>
              </div>
              <add-to-cart-dialog
                v-if="selectedProduct.isOrderable"
                ref="addToCartDialog"
                :disabled="selectedProduct && selectedProduct.isUsed && usedProducts.length > 1"
                :cart-items="addToCartItems"
                :preorder="isPreorder"
                :ad-image-url="addToCartAdURL"
                :ad-click-url="adClickURL"
              />
              <div v-if="!selectedProduct.isOrderable" class="fx-2" />
            </div>
          </client-only>
        </div>
        <div v-else class="product-options-wrapper">
           <div class="error--text font-large font-weight-bold mt-4">
              Item is currently only available for purchase in a bundle
            </div>
            <div class="mt-4">
              <base-button
                text="See Bundle"
                x-large
                @click="goToBundle"
              />
            </div>
        </div>
        <div v-if="selectedProduct.isOrderable && isPreorder" class="font-weight-bold font-medium mt-4 text-right">
          Available for Pre-Order. This item will be released on {{ selectedProduct.latestAvailabilityDate | formatDateLong }}
        </div>
        <div class="product-more-info-wrapper font-weight-light">
          <client-only>
            <p v-if="selectedProduct.descriptionShort" v-html="selectedProduct.descriptionShort || ''" />
          </client-only>
          <span v-show="showProductDetails" v-a11y-clickable class="clickable font-medium primary--text" @click="viewDetails = !viewDetails">{{ viewDetails ? '- Hide' : '+ View' }} Product Details</span>
          <div v-show="showProductDetails && viewDetails" class="font-medium">
            <p class="mt-3">
              <b>Product Details</b><br>
              <span v-if="selectedProduct.publisher">Publisher: {{ selectedProduct.publisher }}<br></span>
              <span v-if="selectedProduct.language">Language: {{ selectedProduct.language }}<br></span>
              <span v-if="selectedProduct.publicationDate">Publication Date: {{ selectedProduct.publicationDate | formatDate }}<br></span>
              <span v-if="selectedProduct.pageCount">Pages: {{ selectedProduct.pageCount }}<br></span>
              <span v-if="selectedProduct.height && selectedProduct.length && selectedProduct.width">
                Dimensions: {{ selectedProduct.length }}" x {{ selectedProduct.width }}" x {{ selectedProduct.height }}", <br>
              </span>
              <span v-if="selectedProduct.isbn10">ISBN-10: {{ selectedProduct.isbn10 }}<br></span>
              <span v-if="selectedProduct.isbn13">ISBN-13: {{ selectedProduct.isbn13 }}<br></span>
              <span v-if="selectedProduct.sku">SKU: {{ selectedProduct.sku }}<br></span>
            </p>
            <p
              v-if="selectedProduct.bible"
              class="mt-3"
            >
              <b>Bible Details</b><br>
              <span v-if="selectedProduct.bible.bibleReferenceLocation">Reference location: {{ selectedProduct.bible.bibleReferenceLocation }}<br></span>
              <span v-if="selectedProduct.bible.bibleTextOrganization">Text Organization: {{ selectedProduct.bible.bibleTextOrganization }}<br></span>
              <span v-if="selectedProduct.bible.studyBibleType">Study Bible Type: {{ selectedProduct.bible.studyBibleType }}<br></span>
              <span
                v-if="selectedProduct.bible.contents && selectedProduct.bible.contents.length"
              >
                Content<span v-if="selectedProduct.bible.contents.length > 1">s</span>:
                <span v-for="(content, i) of selectedProduct.bible.contents" :key="content + '_' + i">
                  {{ content }}
                  <span v-if="i < (selectedProduct.bible.contents.length - 1)">, </span>
                </span>
                <br>
              </span>
              <span
                v-if="selectedProduct.bible.purposes && selectedProduct.bible.purposes.length"
              >
                Purpose<span v-if="selectedProduct.bible.purposes.length > 1">s</span>:
                <span v-for="(purpose, i) of selectedProduct.bible.purposes" :key="purpose + '_' + i">
                  {{ purpose }}
                  <span v-if="i < (selectedProduct.bible.purposes.length - 1)">, </span>
                </span>
                <br>
              </span>
              <span
                v-if="selectedProduct.bible.textFeatures && selectedProduct.bible.textFeatures.length"
              >
                Text Feature<span v-if="selectedProduct.bible.textFeatures.length > 1">s</span>:
                <span v-for="(TextFeature, i) of selectedProduct.bible.textFeatures" :key="textFeature + '_' + i">
                  {{ TextFeature }}
                  <span v-if="i < (selectedProduct.bible.textFeatures.length - 1)">, </span>
                </span>
                <br>
              </span>
              <span
                v-if="selectedProduct.bible.versions && selectedProduct.bible.versions.length"
              >
                Version<span v-if="selectedProduct.bible.versions.length > 1">s</span>:
                <span v-for="(version, i) of selectedProduct.bible.versions" :key="version + '_' + i">
                  {{ version }}
                  <span v-if="i < (selectedProduct.bible.versions.length - 1)">, </span>
                </span>
                <br>
              </span>
            </p>
          </div>
        </div>
        </div>
        <div v-else>
          <div v-if="selectedProduct">
            <e-book-dropdown :isbn="selectedProduct.isbn13" />
          </div>
        </div>
      </v-card>
    </div>
    <client-only>
      <slices-block v-if="slices" :slices="slices" />
    </client-only>
    <client-only>
    <div v-if="selectedProduct && selectedProduct.descriptionLong && showProductDescription">
      <book-summary :summary-text="selectedProduct.descriptionLong" />
    </div>
    </client-only>
    <div v-if="product && authorProducts && authorProducts.length && showAuthorProducts" class="author-products-wrapper">
      <book-cover-reel reel-title="More By This Author" :reel-items="authorProducts" :page-size="5" />
    </div>
    <!-- <div v-if="product && product.id != 25916 && recommendedProducts && recommendedProducts.length && showRelatedProducts" class="related-products-wrapper">
      <book-cover-reel reel-title="Related To This Product" :reel-items="recommendedProducts" :page-size="5" />
    </div> -->
    <client-only>
    <div v-if="selectedProduct && selectedProduct.contributors && showAboutAuthorsSection && showAboutAuthors">
      <book-contributors :contributors="selectedProduct.contributors" />
    </div>
    </client-only>
    <div v-if="selectedProduct && selectedProduct.totalRatings && showProductReviews" class="product-reviews my-md-5">
      <div id="product-review-anchor" />
      <product-reviews
        :isbn="((selectedProduct.isbn13) ? selectedProduct.isbn13 : selectedProduct.isbn10).toString()"
        :rating="selectedProduct.roundedRating"
        :review-count="selectedProduct.totalRatings"
      />
    </div>
    <used-book-selection-dialog
      v-if="selectedProduct"
      :product="selectedProduct"
      :used-products="usedProducts"
      :show-dialog="showUsedBookDialog"
      @closed="usedBookDialogClosed($event)"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { ORGANIZATIONS_TYPES } from '@/store/organizations'
import { CART_TYPES } from '@/store/cart'
import { WISHLISTS_TYPES } from '@/store/wishlists'
import prismicAPI from '@/helpers/prismic-api'
import AddToCartDialog from '@/components/dialogs/add-to-cart-dialog'
import SlicesBlock from '@/components/slices/slices-block'
import UsedBookSelectionDialog from '@/components/dialogs/used-book-selection-dialog'
import ProductReviews from '@/components/pages/products/product-reviews'
import BaseImage from '@/components/base/base-image'
import Ribbon from '@/components/snippets/ribbon'
import VideoDialog from '@/components/dialogs/video-dialog'
import BookCoverReel from '@/components/content-sections/book-cover-reel'
import BookSummary from '@/components/content-sections/book-summary'
import BookContributors from '@/components/content-sections/book-contributors'
import { calculateDiscount, formatDate } from '@/helpers/utilities'
import { LAYOUT_TYPES } from '@/store/layout'
import DateBoughtNotification from '@/components/snippets/date-bought-notification'
import EBookDropdown from '@/components/pages/products/ebook-dropdown'
import * as gaUtility from '@/helpers/ga-utility'

export default {
  name: 'ProductDetail',
  components: {
    VideoDialog,
    ProductReviews,
    UsedBookSelectionDialog,
    BookCoverReel,
    BookSummary,
    BookContributors,
    AddToCartDialog,
    SlicesBlock,
    Ribbon,
    BaseImage,
    DateBoughtNotification,
    EBookDropdown
  },
  data () {
    return {
      slices: null,
      carouselIndex: 0,
      selectedProduct: null,
      quantityToOrder: 1,
      showWishlistTooltip: false,
      wishListTooltipTimeout: null,
      showUsedBookDialog: false,
      viewDetails: false,
      addToCartItems: [],
      productVariants: null,
      // recommendedProducts: [],
      imageLoaded: false,
      showProductDescription: true,
      showAuthorProducts: true,
      showAboutAuthors: true,
      // showRelatedProducts: true,
      showProductReviews: true,
      showFormatOptions: true,
      showProductDetails: true,
      priorityCartMessage: null,
      // add to cart options
      addToCartAdURL: null,
      adClickURL: null,
      isOpen: false
    }
  },
  computed: {
    ...mapState({
      wishlists: state => state.wishlists.lists,
      authenticatedUser: state => state.auth.authenticatedUser
    }),
    ...mapGetters({
      conditionDescriptionByCondition: LAYOUT_TYPES.getters.conditionDescriptionByCondition,
      browsingAs: ORGANIZATIONS_TYPES.getters.browsingAs
    }),
    conditionDescription () {
      return this.conditionDescriptionByCondition(this.selectedProduct.condition)
    },
    showAboutAuthorsSection () {
      for (let i = this.selectedProduct.contributors.length - 1; i >= 0; i--) {
        if (this.selectedProduct.contributors[i].biography && this.selectedProduct.contributors[i].biography.length > 0) {
          return true
        }
      }
      return false
    },
    showPromotionList () {
      if (this.selectedProduct.relatedPromotions === null) { return false }
      let hasSupportedFlag = false
      if (this.selectedProduct.flag) {
        switch (this.selectedProduct.flag) {
          case 'Pre-Release' :
          case 'Pre-Order' :
          case 'New Release' :
          case 'Staff Pick' :
          case 'Best Seller' :
            hasSupportedFlag = true
            break
          default:
            hasSupportedFlag = false
        }
      }
      const noFlagWithMaxPromotions = (!hasSupportedFlag && this.selectedProduct.relatedPromotions.length > 3)
      const hasFlagWithMaxPromotions = (hasSupportedFlag && this.selectedProduct.relatedPromotions.length > 2)
      return noFlagWithMaxPromotions || hasFlagWithMaxPromotions || !this.$vuetify.breakpoint.smAndUp
    },
    shareUrl () {
      return process.env.APP_URL + this.$route.fullPath
    },
    selectedProductTitle () {
      return this.selectedProduct.title + (this.selectedProduct.author ? ' by ' + this.selectedProduct.author : '')
    },
    isUsedSelected () {
      return this.selectedProduct && this.selectedProduct.isUsed
    },
    appliedDiscount () {
      if (!this.selectedProduct || !this.selectedProduct.bulkDiscounts || !this.selectedProduct.bulkDiscounts.length) {
        return null
      }
      for (let i = this.selectedProduct.bulkDiscounts.length - 1; i >= 0; i--) {
        const discount = this.selectedProduct.bulkDiscounts[i]
        if (this.quantityToOrder >= discount.quantity) {
          return discount
        }
      }
      return null
    },
    priceWithBulkDiscountsApplied () {
      if (!this.appliedDiscount) {
        return this.selectedProduct.basePrice
      }

      return +(this.selectedProduct.msrp * (1 - this.appliedDiscount.percentage)).toFixed(2)
    },
    contributors () {
      if (!this.selectedProduct || !this.selectedProduct.contributors) {
        return []
      }
      return this.selectedProduct.contributors.map(x => x.fullName).join(', ')
    },
    formatItems () {
      if (!this.product) {
        return []
      }
      if (!this.usedProducts.length) {
        return this.newProducts
      }
      if (this.usedProducts.length === 1) {
        return [...this.newProducts, ...this.usedProducts] // If there's only 1 used option just skip the dialog
      }
      return [...this.newProducts, { used: true, price: this.lowestPriceUsedOption, id: 0 }]
    },
    productDiscount () {
      return calculateDiscount(this.priceWithBulkDiscountsApplied, this.selectedProduct.msrp)
    },
    itemInWishList () {
      return (this.wishlists[0].items.find(i => i && i.product && i.product.id === this.selectedProduct.id))
    },
    allProducts () {
      if (!this.product || !this.product.groupedProducts) {
        return []
      }
      // filter out ebooks
      return [ this.product, ...this.product.groupedProducts.filter(x => x.productTypeId !== 44)]
    },
    usedProducts () {
      return this.allProducts.filter(x => x.isUsed).sort((a, b) => a.basePrice - b.basePrice)
    },
    newProducts () {
      return this.allProducts.filter(x => !x.isUsed)
    },
    lowestPriceUsedOption () {
      if (!this.product) {
        return null
      }
      return Math.min(...this.usedProducts.map(x => x.basePrice))
    },
    isPreorder () {
      return this.selectedProduct && this.selectedProduct.latestAvailabilityDate &&
        new Date(this.selectedProduct.latestAvailabilityDate) > new Date()
    },
    featuredImageUrl () {
      if (!this.featuredImage) {
        return null
      }
      return this.featuredImage.publisherUrl
        ? (this.$options.filters.fullImagePath(this.featuredImage.publisherUrl, 'L'))
        : this.featuredImage.alternateUrl
    },
    promotionAppliedInCart () {
      const promotion = this.selectedProduct.relatedPromotions.find(x => this.quantityToOrder >= x.quantityMinimum)
      return !!promotion
    }
  },
  watch: {
    quantityToOrder () {
      this.addToCartItems = [{
        product: { ...this.selectedProduct },
        quantityToOrder: this.quantityToOrder
      }]
    }
  },
  head () {
    if (this.product) {
      gaUtility.viewItem(this.product, this.$gtm)
      return {
        title: (this.product) ? this.product.title : 'Product Details',
        meta: [
          { hid: 'title', name: 'title', content: this.selectedProduct.title },
          { hid: 'description', name: 'description', content: this.selectedProduct.descriptionShort },
          { hid: 'og:title', name: 'og:title', content: this.selectedProduct.title },
          { hid: 'og:description', name: 'og:description', content: this.selectedProduct.descriptionShort },
          { hid: 'og:url', name: 'og:url', content: this.shareUrl },
          { hid: 'og:image', name: 'og:image', content: this.featuredImageUrl },
          { hid: 'og:image:alt', name: 'og:image:alt', content: this.selectedProduct.title },
          { hid: 'og:type', name: 'og:type', content: 'books.book' },
          { hid: 'books:isbn', name: 'books:isbn', content: this.selectedProduct.isbn13 },
          { hid: 'books:author', name: 'books:author', content: this.selectedProduct.author },
          { name: 'twitter:card', content: this.featuredImageUrl ? 'summary_large_image' : 'summary' },
          { name: 'twitter:site', content: '@bakerbookstore' }
        ].filter(x => x.content)
      }
    } else {
      return {
        title: 'Product Not Found'
      }
    }
  },
  async asyncData ({ $axios, params, req, error }) {
    try {
      const data = {
        product: null,
        selectedProduct: null,
        featuredImage: null,
        videos: null,
        // recommendedProducts: [],
        authorProducts: []
      }
      const productId = parseInt(params.uuid) || null
      if (!productId) {
        return data
      }
      try {
        const res = await $axios.get(`store/products/${productId}`)
        const product = res.data
        if (product.deleted === true) {
          data.product = null
          data.selectedProduct = null
          data.featuredImage = null
          return data
        }
        data.product = product
        data.selectedProduct = product
        data.featuredImage = { publisherUrl: product.featuredImageUrl }
      } catch (e) {
        console.log(`Caught an error: ${e.statusCode}`)
        if (e.statusCode === 404) {
          data.product = null
          data.selectedProduct = null
          data.featuredImage = null
          return data
        }
        throw e
      }
      /* try {
        if (data.product) {
          await $axios.get(`store/products/${productId}/recommended?count=5`)
            .then((resp) => {
              data.recommendedProducts = resp.data
            })
        }
      } catch (e) {
        // Just don't show recommended products
      } */
      try {
        if (data.product) {
          await $axios.get(`store/products/${productId}/author-suggestions?count=25`)
            .then((resp) => {
              data.authorProducts = resp.data
            })
        }
      } catch (e) {
        // Just don't show recommended products
      }
      const addToCartAd = await prismicAPI.getSingle('cart_content', req)
      if (addToCartAd) {
        // console.log(addToCartAd)
        const cartResult = addToCartAd.document
        if (cartResult && cartResult.add_to_cart_ad && cartResult.add_to_cart_ad.url) {
          data.addToCartAdURL = cartResult.add_to_cart_ad.url
        }
        if (cartResult && cartResult.ad_click_url && cartResult.ad_click_url.url) {
          data.adClickURL = cartResult.ad_click_url.url
        }
        // data.addToCartAdURL = null
      }
      const dynamicContent = await prismicAPI.getByUID('product', `pr-${productId}`, req)
      if (dynamicContent) {
        const result = dynamicContent.document
        data.showProductDescription = !((result.show_product_description != null && result.show_product_description === false))
        data.showAuthorProducts = !((result.show_author_products != null && result.show_author_products === false))
        data.showAboutAuthors = !((result.show_about_authors != null && result.show_about_authors === false))
        // data.showRelatedProducts = !((result.show_related_products != null && result.show_related_products === false))
        data.showProductReviews = !((result.show_product_reviews != null && result.show_product_reviews === false))
        data.showProductDetails = !((result.show_product_details != null && result.show_product_details === false))
        data.showFormatOptions = !((result.show_format_options != null && result.show_format_options === false))
        data.priorityCartMessage = result.priority_cart_message
        data.slices = result.body
        const customImages = data.slices.find(s => s.slice_type === 'images')
        if (customImages && data.product) {
          data.product.images = [
            ...data.product.images,
            ...customImages.items.map((ci) => {
              return {
                name: ci.custom_image.alt,
                alternateUrl: ci.custom_image.url
              }
            })
          ]
        }
        const embeddedContent = data.slices.find(s => s.slice_type === 'embedded_content')
        if (embeddedContent) {
          data.videos = embeddedContent.items.map(x => x.embedded_content).filter(x => !!x)
        }
      }
      data.addToCartItems = [{
        product: { ...data.selectedProduct },
        quantityToOrder: 1
      }]
      return data
    } catch (e) {
      error(e)
    }
  },
  async middleware ({ $axios, params, redirect, error }) {
    const num = Number(params.uuid)

    if (isNaN(num)) {
      try {
        const res = await $axios.get('/store/products', { params: { search: params.uuid } })
        console.log(`result is ${res.data}`)
        if (res && res.data) {
          redirect(`/products/${res.data}`)
        } else {
          error({ statusCode: 404, message: 'Product not found' })
        }
      } catch (e) {
        error(e && e.message ? e.message : e)
      }
    }
  },
  methods: {
    ...mapActions({
      addItemsToCart: CART_TYPES.actions.addItemsToCart,
      addProductToWishList: WISHLISTS_TYPES.actions.addProductToWishList,
      removeProductFromWishList: WISHLISTS_TYPES.actions.removeProductFromWishList
    }),
    selectImage (image, index) {
      this.selectedProduct.images.splice(index, 1) // Remove selected images from side images
      this.selectedProduct.images.push(this.featuredImage) // Move featured image to the side with the other supporting images
      this.featuredImage = image // Move selected image to the featured image spot
    },
    selectFormatOptionFromList (listItem) {
      if (listItem.used) {
        this.showUsedBookDialog = true
      } else {
        this.selectFormatOption(listItem)
      }
    },
    selectFormatOption (option) {
      if (option.id === this.selectedProduct.id) {
        return
      }

      this.selectedProduct = option
      this.featuredImage = { publisherUrl: this.selectedProduct.featuredImageUrl }

      this.addToCartItems = [{
        product: { ...this.selectedProduct },
        quantityToOrder: 1
      }]
    },
    resetTooltipTimeout () {
      if (this.wishListTooltipTimeout) {
        this.showWishlistTooltip = false
        clearTimeout(this.wishListTooltipTimeout)
      }
    },
    addToWishList () {
      this.addProductToWishList(this.product)
      this.resetTooltipTimeout()
      this.showWishlistTooltip = true
      this.wishListTooltipTimeout = setTimeout(() => {
        this.showWishlistTooltip = false
      }, 2000)
    },
    removeFromWishList () {
      this.removeProductFromWishList(this.product)
      this.resetTooltipTimeout()
    },
    async usedBookDialogClosed (selected) {
      this.showUsedBookDialog = false
      if (!selected || !selected.length) {
        return
      }
      this.selectedProduct = selected[0].product
      const items = await this.addItemsToCart(selected)
      this.addToCartItems = items.filter(x => selected.some(y => y.product.id === x.product.id))
      this.$refs.addToCartDialog.dialog = true
    },
    goToBundle () {
      this.$router.push(`/bundles/` + this.product.bundleId)
    },
    isOrderedBefore () {
      if (this.authenticatedUser && this.authenticatedUser.orders) {
        for (let i = 0; i < this.authenticatedUser.orders.length; i++) {
          for (let j = 0; j < this.authenticatedUser.orders[i].productIds.length; j++) {
            const orderProductId = this.authenticatedUser.orders[i].productIds[j]
            if (orderProductId === this.product.id) {
              return '<div style="border: 1px solid rgb(124, 185, 54); font-size: 15px; margin: 20px; padding:20px;"><div style="float: left; margin-right: 10px;"><i style="color:green; font-size:20px; vertical-align:text-bottom;" class="mdi mdi-checkbox-marked-circle"></i></div><div style="vertical-align:text-bottom; margin-top: 5px;">Previously purchased on ' + formatDate(this.authenticatedUser.orders[i].createdAt, "MMM D, YYYY") + "</div></div>"
            }
          }
        }
      }
    },
    IsGiftCard () {
      // redirect away to the gift card purchase page if the user happens to pass the ID of an individual gift card product into the URL
      if (this.product && this.product.productTypeId === -1) {
        this.$router.push(`/gift-cards/buy/single`)
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../scss/variables';
  .previouslyPurchased {
    border: 1px solid rgb(124, 185, 54); font-size: 15px; margin: 20px; padding:20px;
  }
  .product-promotions {
    padding-bottom:1em;
    .multiple-ribbon {
      background:transparent !important;
      color:$dark-blue !important;
      display:block;
      clear:left;
      &:before {
        display:none !important;
      }
      &:after {
        display:none !important;
      }
      /* .multiple-ribbon-content {
        padding-left:.5em !important;
      } */
    }
  }
  .product-card-wrapper {
    padding: 3.2em;
  }

  .ribbon-padding {
    padding-top:2em;
  }
  .v-input {
    font-size: 10px;
  }

  .wishlist-tooltip {
    padding: 10px;
  }

  .discount-list {
    list-style-type: none;
    padding-left: 0 !important;
  }

  .share-network-container{
    padding-left: 10px;
    .share-network-title {
      font-size: $font-small;
      font-weight:700;
      color: $charcoal-grey;
    }
    .social-network-item {
      text-decoration: none;
      .mdi {
          background-color:$dark-blue;
          color:$white !important;
          font-size: 18px !important;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          height:24px;
          width:24px;
          border-radius: 100%;
      }
    }
  }
  @media screen and (max-width: 450px) {
    .product-photos-wrapper {
      width: 100%;
    }
  }

  .product-detail-wrapper {
    .priority-cart-message {
      font-size: 1.5em;
      color: $error-orange;
    }
    .favorite-icon {
      width: 32px;
      height: 32px;
      border: 1.2px solid $dark-blue;
      border-radius: 100% !important;
      display: flex;
      justify-content: center;
      position: absolute;
      top: 32px;
      right: 32px;

      .v-icon {
        padding-top: 2px;
      }
    }

    .product-photos-wrapper {
      padding: 0 30px 0 18px;

      .product-photos {
        .photo-container {
          padding: 1em;

          div {
            width: 32.8em;
          }
        }

        .video-container {
          position: relative;

          .video-overlay {
            position: absolute;
            z-index: 1;
            height: 33%;
            top: 33%;
            left: 37%;
            opacity: 0.75;
          }
        }

        .photo-actions {
          margin: 2.4em 1.5em;

          span {
            font-size: 1.6em;
            font-weight: $font-weight-bold;
          }
        }
      }
    }

    .product-card-wrapper {
      max-width: 58.8em;

      .product-about-wrapper {
        padding-bottom: 20px;
        border-bottom: 1px solid $grey;

        .v-card__title {
          max-width: calc(100% - 40px);
          word-break: normal;
          line-height: 1em;
          font-size: 3.5em;
          padding: 0;
          font-weight: $font-weight-bold;
        }
        .v-card__subtitle {
          max-width: calc(100% - 60px);
          word-break: normal;
          line-height: 1em;
          font-size: 2em;
          padding: 0;
          font-weight: 700;
          padding-top: 1.2em;
          color: $grey;
        }

        .v-card__text {
          margin-top: 1em;
          padding: 0;
          font-size: $font-medium;
          font-weight: $font-weight-bold;
        }

        .product-reviews-wrapper {
          margin-top: 1.6em;

          a {
            line-height: 1.6em;
            margin: 0.5em 0 0 1.6em;
            font-size: $font-medium;
            text-decoration: none;
          }
        }
      }

      .product-options-wrapper {
        .section-heading {
          margin-top: 2.4em;
          margin-bottom: 1em;

          span {
            font-size: $font-default-size;
            font-weight: $font-weight-thin;
          }
        }

        .product-pricing-wrapper {
          .new-value {
            font-size: 3.5em;
            margin-right: 1em;
          }
          .new-value-icon {
            font-size: 3em;
            margin-right: -5px;
            vertical-align:middle;
          }
          .old-price {
            font-size: 1.6em;

            .price {
              text-decoration: line-through;
            }
          }

          .special-offers {
            .v-icon {
              font-size: 14px;
            }
          }
        }
        .new-value-price {
            font-size:1em;
            margin-right: -2px;
            vertical-align:middle;
            margin-top:-3px;
          }
        .used-text {
          max-width: 10.8em;
          padding-top: 2px;
        }

        .format-options-wrapper {
          font-size: 1.5em;
          margin: 0 -0.6em;

          .option {
            width: 10.8em;
            border-radius: 4px;
            border: 1px solid $dark-blue;
            background: none;
            padding: 10px 16px 10px 16px;
            margin: 0 0.6em 1.6em 0.6em;

            &.selected {
              background-color: rgba($dark-blue, 0.2);
            }

            &.disabled {
              border: 1px solid $dark-grey;
              background: rgba(216, 216, 216, 0.3);
              opacity: 0.5;
              cursor: default;
            }
          }
        }

        .cart-actions-wrapper {
          margin-top: 8px;

          .quantity {
            flex: 1;
          }

          .base-quantity-select {
            min-width: 140px;
          }
        }
      }
    }

    .product-more-info-wrapper {
      border-top: 1px solid $grey;
      margin-top: 20px;
      padding-top: 20px;
      font-size: 1.6em;

      span.clickable {
        font-weight: $font-weight-bold;
      }
    }
  }

  .special-offers {
    cursor: default;
  }

  #product-review-anchor {
    visibility: hidden;
    position: relative;
    top: -250px;
  }

  @media screen and (max-width: $breakpoint-sm) {
    .v-card__title {
      font-size: 19px !important;
    }
    .v-card__subtitle {
          max-width: calc(100% - 40px);
          font-size: 17px !important;
        }
    .v-card__text, .product-reviews-wrapper a, .section-heading span, .special-offers, .product-more-info-wrapper {
      font-size: 12px !important;
    }

    .cart-actions-wrapper {
      margin-top: 12px !important;

      .quantity {
        margin-bottom: 12px;
      }
    }
  }
</style>
